<button type="button"
        [ngStyle]="attributes.style"
        [style.opacity]="(attributes.withTimer && (timerService.isInUse$(attributes.name) | async)) ? 0.5 : null"
        [disabled]="attributes.disabled"
        [ngClass]="attributes.class"
        (click)="onClick()">
  <span>
    <app-button-label [labelKey]="attributes.labelKey"/>
    <ng-container *ngIf="attributes.withTimer && (timerService.isInUse$(attributes.name) | async)">
      {{ " (" + (timerService.timeLeft$(attributes.name) | async) + ")" }}
    </ng-container>
  </span>
</button>
